// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivateClasses_root__CtL7P","detailBoxLabel":"PrivateClasses_detailBoxLabel__rnab_","stickyWrapper":"PrivateClasses_stickyWrapper__xoPUp"};